import React from 'react';
import useRequestPrintForm from '../../../../queries/useRequestPrintForm';
import PrintOneForm from './ui/PrintOneForm';
import PrintMultipleForms from './ui/PrintMultipleForms';

const RequestPrintForm = ({ actionStyle, requestIds }) => {
  const { data: printForms } = useRequestPrintForm();

  if (!printForms?.length) {
    return null;
  }

  const props = {
    actionStyle,
    requestIds,
    printForms,
  };

  return printForms.length > 1 ? (
    <PrintMultipleForms {...props} />
  ) : (
    <PrintOneForm {...props} />
  );
};

export default RequestPrintForm;
